
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { ZipProgressData } from '@/types';

@Component
export default class ArchiveOperationDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Number) readonly operationId!: number;

  dialog = this.value;

  checking = true;
  isOperationClosedOrCompleted = false;
  // isOperationFailed = false;

  zipping = false;
  isZipReady = false;
  isZipEmpty = false;

  downloading = false;

  uploading = false;
  isZipUploaded = false;

  verifying = false;
  isZipVerified = false;

  archiving = false;

  error = false;
  errorMessage = '';

  get zipUploadProgress(): ZipProgressData | null {
    return this.$store.getters.currentZipUploadProgress;
  }

  get zipVerifyProgress(): ZipProgressData | null {
    return this.$store.getters.currentZipVerifyProgress;
  }

  get uploadProgressPercent(): number {
    return this.zipUploadProgress?.percent || 0;
  }

  get verifyProgressPercent(): number {
    return this.zipVerifyProgress?.percent || 0;
  }

  get uploadProgressDone(): boolean {
    return this.zipUploadProgress?.done || false;
  }

  get verifyProgressDone(): boolean {
    return this.zipVerifyProgress?.done || false;
  }

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;

    // Quando apre il dialog...
    if (val) {
      // ... resetta il progresso
      this.checking = true;
      this.isOperationClosedOrCompleted = false;
      // this.isOperationFailed = false;
      this.isZipReady = false;
      this.isZipEmpty = false;
      this.zipping = false;
      this.isZipUploaded = false;
      this.uploading = false;
      this.isZipVerified = false;
      this.verifying = false;

      // ... resetta l'errore
      this.error = false;
      this.errorMessage = '';

      // ... controlla lo stato della commessa e delle sue figlie
      this.onCheckOperationStatus();
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  @Watch('uploadProgressDone')
  onUploadProgressDone(val: boolean) {
    if (val) {
      this.isZipUploaded = true;
      this.uploading = false;
      this.error = false;
    }
  }

  @Watch('verifyProgressDone')
  onVerifyProgressDone(val: boolean) {
    if (val) {
      this.isZipVerified = true;
      this.verifying = false;
      this.error = false;
    }
  }

  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    // Se sta facendo qualcosa, non permette di chiudere il dialog
    if (this.checking || this.zipping || this.downloading
      || this.uploading || this.verifying || this.archiving) {
      return;
    }

    // Se viene chiuso il dialog, rimuove lo ZIP
    this.$store.dispatch('removeOperationZip', { id: this.operationId });

    this.dialog = false;
  }

  // Verifica se la commessa e tutte le sue figlie sono chiuse o completate
  async onCheckOperationStatus() {
    console.log(`${this.constructor.name}: onCheckOperationStatus()`); // eslint-disable-line no-console

    this.checking = true;

    try {
      const result = await this.$store.dispatch('checkOperationStatus', { id: this.operationId });
      this.isOperationClosedOrCompleted = result === 'done';
      // this.isOperationFailed = result === 'failed';
      this.checking = false;
      this.error = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onCheckOperationStatus() message =`, message); // eslint-disable-line no-console
      this.checking = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante il controllo dello stato della commessa (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante il controllo dello stato della commessa';
      }
    }
  }

  async onCreateZip() {
    console.log(`${this.constructor.name}: onCreateZip()`); // eslint-disable-line no-console

    this.zipping = true;

    try {
      const result = await this.$store.dispatch('createOperationZip', { id: this.operationId });
      console.log(`${this.constructor.name}: onCreateZip() result =`, result); // eslint-disable-line no-console
      this.zipping = false;
      if (result?.size === 0) {
        this.isZipEmpty = true;
      } else {
        this.isZipReady = true;
      }
      this.error = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onCreateZip() message =`, message); // eslint-disable-line no-console
      this.zipping = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante la creazione dell'archivio (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante la creazione dell\'archivio';
      }
    }
  }

  async onDownloadZip() {
    console.log(`${this.constructor.name}: onDownloadZip()`); // eslint-disable-line no-console

    this.downloading = true;

    try {
      await this.$store.dispatch('downloadOperationZip', { id: this.operationId });
      this.downloading = false;
      this.error = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onDownloadZip() message =`, message); // eslint-disable-line no-console
      this.downloading = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante il download dell'archivio (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante il download dell\'archivio';
      }
    }
  }

  async onUploadZip() {
    console.log(`${this.constructor.name}: onUploadZip()`); // eslint-disable-line no-console

    this.uploading = true;

    try {
      await this.$store.dispatch('uploadOperationZip', { id: this.operationId });
      // this.isZipUploaded = true;
      // this.uploading = false;
      // this.error = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onUploadZip() message =`, message); // eslint-disable-line no-console
      this.uploading = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante il backup dell'archivio (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante il backup dell\'archivio';
      }
    }
  }

  async onVerifyZip() {
    console.log(`${this.constructor.name}: onVerifyZip()`); // eslint-disable-line no-console

    this.verifying = true;

    try {
      await this.$store.dispatch('verifyOperationZip', { id: this.operationId });
      // this.isZipVerified = true;
      // this.verifying = false;
      // this.error = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onVerifyZip() message =`, message); // eslint-disable-line no-console
      this.verifying = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante la verifica dell'archivio: (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante la verifica dell\'archivio';
      }
    }
  }

  async onArchiveOperation() {
    console.log(`${this.constructor.name}: onArchiveOperation()`); // eslint-disable-line no-console

    this.archiving = true;

    try {
      await this.$store.dispatch('archiveOperation', { id: this.operationId });
      this.archiving = false;
      this.error = false;
      this.dialog = false;
    } catch (error) {
      const message = (error as any).response?.data?.message || (error as any)?.message;
      console.error(`${this.constructor.name}: onArchiveOperation() message =`, message); // eslint-disable-line no-console
      this.archiving = false;
      this.error = true;
      if (message) {
        this.errorMessage = `Errore durante l'archiviazione della commessa (${message})`;
      } else {
        this.errorMessage = 'Errore sconosciuto durante l\'archiviazione della commessa';
      }
    }
  }
}
